import Container from "@components/Atomic/Container/Container";
import React from "react";
import tw from "twin.macro";
import FeaturedArticleCard from "./FeaturedArticleCard";
import { withFeaturedArticle } from "./withFeaturedArticle";

const OuterWrapper = tw.div`
  w-full py-mega max-w-2xl mx-auto px-mini sm:px-maxi md:p-tera
`;

const Wrapper = tw.div`
  flex flex-wrap md:-mx-mini
`;

export const FeaturedArticle = withFeaturedArticle(
  ({ articles, articlesSource, featuredArticles, styles }) => {
    return (
      <Container
        styles={styles}
        data-component-type="section-featured-article"
        data-testid="featured-article"
      >
        <OuterWrapper>
          <Wrapper>
            {articlesSource === "filterByCategory" ? (
              <>
                {featuredArticles?.map((featuredArticle) => (
                  <FeaturedArticleCard
                    key={featuredArticle?._id}
                    article={featuredArticle}
                    dataTestId="filtered-article"
                  />
                ))}
              </>
            ) : (
              <>
                {articles?.map((article) => (
                  <FeaturedArticleCard
                    key={article?.id}
                    article={article}
                    dataTestId="selected-article"
                  />
                ))}
              </>
            )}
          </Wrapper>
        </OuterWrapper>
      </Container>
    );
  },
);
